import styled, { css } from 'styled-components';

export const MainContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  & h1 {
    margin: 0;
    font-size: 20px;
  }
`;

export const KpiContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  scrollbar-width: none !important;
  height: 100%;
  width: 100%;
  padding: 0 5% 2%;
  box-sizing: border-box;
`;

export const KpiWrapper = styled.div`
  border: 0px;
  padding: 0px;
  margin: 0px;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

export const KpiTitle = styled.div`
  border: 0px;
  padding: 0px;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
`;

interface KpiCardProps {
  titleFontSize: string;
  showTitle: boolean;
  kpiType: string;
}

export const KpiCard = styled.div<KpiCardProps>`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  ${({ titleFontSize, showTitle, kpiType }) => css`
    overflow: ${['label', 'smartLabel', 'Table', 'Content'].includes(kpiType) ? 'hidden' : 'initial'};

    ${KpiTitle} {
      height: ${`max(${titleFontSize}px, 10%)`};
    }

    ${KpiWrapper} {
      height: ${showTitle ? `calc(100% - max(${titleFontSize}px, 10%))` : '100%'};
    }
  `}
`;

export const ResumeContainer = styled.div`
  display: flex;
  width: 300px;
  position: relative;
  & p {
    margin: 5px 10px;
    font-size: 14px;
    white-space: pre-wrap;
  }
  &:before {
    content: '';
    position: absolute;
    border: 16px solid;
    border-color: transparent white;
    top: -12px;
    border-right: 0px;
    left: 10px;
    border-width: 16px 16px 0;
  }
`;
